module.exports = __webpack_public_path__ + "detail2.af3f62f8.png";